import axios from 'axios';
import { Component } from "react";
import { baseUrl, config } from './index.js';
const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
export default class ProductService extends Component {
  static fetchAllProducts = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_all_products?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      const response = await axios(config);

      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static fetchProductsByBlog = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_country_single_product?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static fetchAllProduct = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_all_product?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };
  static fetchPendingProducts = async () => {
    try {
      config.url = baseUrl + '/wp/v2/get_all_products_pending?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  // static fetchAllApprovedProducts = async (data) => {
  //   try {
  //     config.url = baseUrl + '/wp/v2/get_all_product';
  //     config.method = 'get';
  //     config.params = data;
  //     const response = await axios(config);
  //     return response.data ? response.data : [];
  //   } catch (error) {
  //     const { response } = error;
  //     if (!response) return;
  //     console.log(`FETCH GET ERROR`, response);
  //   }
  // };

  static getProductById = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_product_id?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      data.lang = localStorage.getItem('localLang');
      config.data = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAllProductByCountry = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/product_cat_stats?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      data.lang = localStorage.getItem('localLang');
      config.data = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static addProduct = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/create_product?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.params = '';
      data.lang = localStorage.getItem('localLang');
      console.log("demo===", data)
      config.data = data;
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };

  static updateProduct = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/update_product?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.params = '';
      data.lang = localStorage.getItem('localLang');
      config.data = data;
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };

  static updateStatus = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/approve_product?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.params = '';
      data.lang = localStorage.getItem('localLang');
      config.data = data;
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };

}
